import React from "react";
import "../../styles/DogInfoTab.css";

const DogInfoTab = ({ dog, owner }) => {
    const formatAddress = (address) => {
        if (!address) return "Brak danych";
        return `${address.street} ${address.buildingNumber}${address.apartmentNumber ? "/" + address.apartmentNumber : ""}, ${address.postalCode} ${address.city}, ${address.country}`;
    };

    if (!dog) {
        return <div className="dog-info-tab__loading">Ładowanie danych psa...</div>;
    }

    return (
        <div className="dog-info-tab">
            {/* Dog Information Section */}
            <div className="dog-info-tab__section">
                <h3 className="dog-info-tab__section-title">Informacje o zwierzęciu</h3>

                {/* All dog fields in one row for flexible layout */}
                <div className="dog-info-tab__row dog-info-tab__row--dog-info">
                    <div className="dog-info-tab__field-group">
                        <label className="dog-info-tab__label">Imię</label>
                        <input
                            className="dog-info-tab__input"
                            type="text"
                            value={dog.name || "jakieś imię"}
                            disabled
                            placeholder="jakieś imię"
                        />
                    </div>
                    <div className="dog-info-tab__field-group">
                        <label className="dog-info-tab__label">Rasa</label>
                        <input
                            className="dog-info-tab__input"
                            type="text"
                            value={dog.breed || "rasa"}
                            disabled
                            placeholder="rasa"
                        />
                    </div>
                    <div className="dog-info-tab__field-group">
                        <label className="dog-info-tab__label">Wiek</label>
                        <input
                            className="dog-info-tab__input"
                            type="text"
                            value={dog.age || "wiek"}
                            disabled
                            placeholder="wiek"
                        />
                    </div>
                    <div className="dog-info-tab__field-group">
                        <label className="dog-info-tab__label">Płeć</label>
                        <input
                            className="dog-info-tab__input"
                            type="text"
                            value={dog.gender || "płeć"}
                            disabled
                            placeholder="płeć"
                        />
                    </div>
                </div>
            </div>

            {/* Owner Information Section */}
            {owner && (
                <div className="dog-info-tab__section dog-info-tab__owner-section">
                    <h3 className="dog-info-tab__section-title">Informacje o właścicielu</h3>

                    {/* All owner fields in one row for flexible layout */}
                    <div className="dog-info-tab__row dog-info-tab__row--owner-info">
                        <div className="dog-info-tab__field-group">
                            <label className="dog-info-tab__label">Imię</label>
                            <input
                                className="dog-info-tab__input"
                                type="text"
                                value={owner.firstName || "jakieś imię"}
                                disabled
                                placeholder="jakieś imię"
                            />
                        </div>
                        <div className="dog-info-tab__field-group">
                            <label className="dog-info-tab__label">Nazwisko</label>
                            <input
                                className="dog-info-tab__input"
                                type="text"
                                value={owner.lastName || "nazwisko"}
                                disabled
                                placeholder="nazwisko"
                            />
                        </div>
                        <div className="dog-info-tab__field-group">
                            <label className="dog-info-tab__label">E-mail właściciela</label>
                            <input
                                className="dog-info-tab__input"
                                type="text"
                                value={owner.email || "e-mail właściciela"}
                                disabled
                                placeholder="e-mail właściciela"
                            />
                        </div>
                        <div className="dog-info-tab__field-group">
                            <label className="dog-info-tab__label">Telefon</label>
                            <input
                                className="dog-info-tab__input"
                                type="text"
                                value={owner.phone || "numer telefonu"}
                                disabled
                                placeholder="numer telefonu"
                            />
                        </div>
                        <div className="dog-info-tab__field-group">
                            <label className="dog-info-tab__label">Adres</label>
                            <input
                                className="dog-info-tab__input"
                                type="text"
                                value={formatAddress(owner.address) || "adres właściciela"}
                                disabled
                                placeholder="adres właściciela"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DogInfoTab;